import { Box } from '@mui/material'
import {FC, useEffect} from 'react'
import { FundingGoalStats } from '../Shared'
import { AwardedGrantsTable } from './AwardedGrantsTable'
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch} from "../../../../store";
import {TechGrantsActions, TechGrantSelectors} from "../../../../store/technology";

export const FundingGoals: FC = () => {
    const dispatch = useDispatch<AppDispatch>()

    const paging = useSelector(TechGrantSelectors.getPaging)

    const { limit, skip } = paging

    useEffect(() => {
        const options = {
            params: {
                outcome: 'win',
                $skip: skip,
                $limit: limit,
            },
        }

        dispatch(TechGrantsActions.fetchCurrentUserMatchedGrantsAsync({ options }))
    }, [dispatch, limit, skip])

  return (
    <Box width="100%">
      <FundingGoalStats showActionButtons={true} />
      <AwardedGrantsTable />
    </Box>
  )
}
